import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { People } from '~/services/Http';

export interface Props {
  employee: People.EmployeeProfileDto;
}

export const EmployeeInfo: React.FC<Props> = ({ employee }) => {
  const { t } = useTranslation();
  const manager = employee.manager;

  return (
    <>
      <Typography gutterBottom variant="h6">
        {t('employeeInfo')}
      </Typography>

      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('position')}</strong>}:{' '}
        <span data-cy="position">{employee.positionName.value}</span>
      </Typography>
      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('manager')}</strong>}:{' '}
        <span data-cy="manager">
          {manager ? `${manager.firstName} ${manager.lastName}` : ' - '}
        </span>
      </Typography>
      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('phone')}</strong>}:{' '}
        <span data-cy="phone">{employee.contact.work?.phone || ' - '}</span>
      </Typography>
      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('mobile')}</strong>}:{' '}
        <span data-cy="mobile">{employee.contact.work?.mobile || ' - '}</span>
      </Typography>
      <Typography component="span" variant="body2" style={{ display: 'block' }}>
        {<strong>{t('email')}</strong>}:{' '}
        <span data-cy="email">{employee.contact.work?.email || ' - '}</span>
      </Typography>
    </>
  );
};
